// extracted by mini-css-extract-plugin
module.exports = {"load-shedding-P":"P_load-shedding-P__Pgh5_"};